import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	output,
} from '@angular/core';
import { InfoClearingToggleCopy, Product, ProductEnum } from '@uc/web/shared/data-models';
import { ClearingToggleComponent } from '../clearing-toggle/clearing-toggle.component';
import { CLEARING_ENABLED } from '@uc/web/config';

@Component({
	selector: 'uc-info-clearing-toggle',
	imports: [ClearingToggleComponent],
	templateUrl: './info-clearing-toggle.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoClearingToggleComponent {
	product = input.required<string>();
	copy = input.required<InfoClearingToggleCopy>();
	clearingChange = output<Product>();

	isCLE = computed(() => this.product() === ProductEnum.Clearing);
	isPG = computed(() => this.product() === ProductEnum.Postgraduate);

	title = computed(() => {
		const title = this.isCLE()
			? this.copy().clearing_on.title
			: this.copy().clearing_off.title;
		return title.replace('[YEAR]', this._currentYear.toString());
	});

	description = computed(() => {
		const description = this.isCLE()
			? this.copy().clearing_on.desc
			: this.copy().clearing_off.desc;
		return description
			.replace('[CURRENT_YEAR]', this._currentYear.toString())
			.replace('[NEXT_YEAR]', this._nextYear.toString());
	});

	readonly clearingEnabled = CLEARING_ENABLED;
	private _currentYear = new Date().getFullYear();
	private _nextYear = new Date().getFullYear() + 1;

	onClearingToggleChange = (isClearing: boolean) => {
		const product = isClearing ? ProductEnum.Clearing : ProductEnum.Undergraduate;
		this.clearingChange.emit(product);
	};
}
